/**
 * Error codes returned by the AppAuth plugin
 */
export enum AppAuthErrorCode {
	// Configuration errors
	INVALID_CONFIG = 'INVALID_CONFIG',
	INVALID_ISSUER_URL = 'INVALID_ISSUER_URL',
	INVALID_REDIRECT_URL = 'INVALID_REDIRECT_URL',
	DISCOVERY_FAILED = 'DISCOVERY_FAILED',

	// Initialization errors
	NOT_INITIALIZED = 'NOT_INITIALIZED',

	// User action errors
	USER_CANCELLED = 'USER_CANCELLED',

	// Sign in errors
	SIGN_IN_FAILED = 'SIGN_IN_FAILED',
	AUTH_RESPONSE_FAILED = 'AUTH_RESPONSE_FAILED',

	// Sign out errors
	SIGN_OUT_FAILED = 'SIGN_OUT_FAILED',
	SIGN_OUT_RESPONSE_FAILED = 'SIGN_OUT_RESPONSE_FAILED',
	NO_ID_TOKEN = 'NO_ID_TOKEN',

	// Sign up errors
	SIGN_UP_FAILED = 'SIGN_UP_FAILED',
	EMAIL_VERIFICATION_PENDING = 'EMAIL_VERIFICATION_PENDING',
	EMAIL_VERIFICATION_REQUIRED = 'EMAIL_VERIFICATION_REQUIRED',
	TOKEN_REQUEST_FAILED = 'TOKEN_REQUEST_FAILED',

	// Token errors
	TOKEN_EXCHANGE_FAILED = 'TOKEN_EXCHANGE_FAILED',
	TOKEN_RESPONSE_FAILED = 'TOKEN_RESPONSE_FAILED',
	TOKEN_REFRESH_FAILED = 'TOKEN_REFRESH_FAILED',
	NO_REFRESH_TOKEN = 'NO_REFRESH_TOKEN',
}
